import React from 'react';

import WatchDataStatisticsView from '../components/organisms/WatchDataStatisticsView';
import PageTemplate from '../components/templates/PageTemplate';

const ReportsContainer = () => {
  return (
    <PageTemplate>
      {/* ph-no-capture: exclude activity/watch data PII from PostHog autocapture */}
      <div className="ph-no-capture">
        <WatchDataStatisticsView />
      </div>
    </PageTemplate>
  );
};

export default ReportsContainer;
